import React from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import BonusPresenter from '../../../../../../../../../../presenters/Membership/BonusPresenter';
import Row from '../../../../../../../../../../components/Row';
import Column from '../../../../../../../../../../components/Column';
import { validationSchema } from '../../../../../../../../../../forms/bonusForm';

const NewBonusForm = (props) => {
  const { initialValues, onSubmit, availableBonusTypes } = props;

  const formik = useFormik({
    initialValues,
    onSubmit,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, setFieldValue } = formik;

  const handleBonusChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
  };

  const typeOptions = availableBonusTypes.map((type) => {
    return {
      label: BonusPresenter.typeReadable({
        bonusType: type,
      }),
      value: type,
    };
  });

  return (
    <tr>
      <td className="cell"> -- </td>
      <td className="cell"> -- </td>
      <td colSpan="2">
        <form onSubmit={handleSubmit}>
          <Row>
            <Column>
              <select id="bonusType" onChange={handleBonusChange} required>
                {typeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </Column>
            <Column>
              <button className="action-button" type="submit">
                Create Bonus
              </button>
            </Column>
          </Row>
        </form>
      </td>
      <td className="cell"> -- </td>
    </tr>
  );
};

export default NewBonusForm;

NewBonusForm.propTypes = {
  initialValues: PropTypes.shape().isRequired,
  availableBonusTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSubmit: PropTypes.func.isRequired,
};
